module.exports = __webpack_public_path__ + "static/media/imagecarousal2.c6731cc6.png";